import * as types from "./types";
import * as appActions from "./actions";
import { createLogic } from "redux-logic";
import { setAuthToken } from "app/utils/auth";
import axios from "axios";
import api from "app/routes/api";

const loginLogic = createLogic({
  type: types.LOGIN,
  latest: true,
  process({ getState, action }, dispatch, done) {
    const { email, password } = action.payload;
    axios
      .post(api.LOGIN, {
        email,
        password,
      })
      .then((res) => {
        const {
          token,
          user: { email, name, networkId },
        } = res.data;
        setAuthToken("Bearer " + token);
        localStorage.setItem("maze-io-token", token);
        dispatch(appActions.loginSuccess({ token, name, email, networkId }));
      })
      .catch((err) => {
        console.log("Error", err.response);
        dispatch(
          appActions.loginFailed({
            errMsg: "Server error",
            errors: err.response.data,
          })
        );
      })
      .finally(() => {
        done();
      });
  },
});

const validateSessionLogic = createLogic({
  type: types.VALIDATE_SESSION,
  latest: true,
  process({ getState, action }, dispatch, done) {
    const token = localStorage.getItem("maze-io-token");
    if (token) {
      console.log("token found");
      axios
        .post(api.VALIDATE_SESSION, {
          token,
        })
        .then((res) => {
          console.log(res);
          const { success } = res.data;
          if (success) {
            const {
              user: { email, name, networkId },
            } = res.data;
            console.log("Succeed", email, name, networkId);

            setAuthToken(token);
            dispatch(
              appActions.loginSuccess({ token, name, email, networkId })
            );
            console.log("Succeed@@");
          }
        })
        .catch((err) => {
          console.log("Error while validating", err.response);
        })
        .finally(() => {
          done();
        });
    } else {
      console.log("token not found");
      done();
    }
  },
});

const registerLogic = createLogic({
  type: types.REGISTER,
  latest: true,
  process({ getState, action }, dispatch, done) {
    const { name, email, password, password2 } = action.payload;
    axios
      .post(api.REGISTER, {
        name,
        email,
        password,
        password2,
      })
      .then((res) => {
        dispatch(appActions.registerSuccess());
        setTimeout(() => {
          dispatch(appActions.resetRegistrationFlag());
          done();
        }, 1000);
      })
      .catch((err) => {
        dispatch(
          appActions.registerFailed({
            errMsg: "Server error",
            errors: err.response.data,
          })
        );
        done();
      });
  },
});

const logoutLogic = createLogic({
  type: types.LOGOUT,
  latest: true,
  process({ getState, action }, dispatch, done) {
    setAuthToken();
    localStorage.removeItem("maze-io-token");
    done();
  },
});

export default [loginLogic, logoutLogic, registerLogic, validateSessionLogic];
